import { css } from '@emotion/core';
import { Theme, titleText } from 'features/Theme';

const styles = {
  titleText: (theme: Theme) => css`
    ${titleText(theme)};
  `,
};

export default styles;
